/* eslint-disable comma-dangle */
/* eslint-disable quotes */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-cycle
import { httpState, socks4State, socks5State } from '@/composables/free-proxies';
import http from '@/services/http-common';

class FproxyService {
  proxyInfoHttp(): Promise<any> {
    const qParams = {
      params: {
        request: 'proxyinfo',
        protocol: httpState.type,
        timeout: httpState.timeout,
        country: httpState.country,
        anonymity: httpState.anonymity,
        ssl: httpState.ssl,
      },
    };
    // console.log(qParams);

    return http.get('https://api.proxyscrape.com/v2/', qParams);
  }

  proxyInfoSocks4(): Promise<any> {
    const qParams = {
      params: {
        request: 'proxyinfo',
        protocol: socks4State.type,
        timeout: socks4State.timeout,
        country: socks4State.country,
      },
    };
    // console.log(qParams);

    return http.get('https://api.proxyscrape.com/v2/', qParams);
  }

  proxyInfoSocks5(): Promise<any> {
    const qParams = {
      params: {
        request: 'proxyinfo',
        protocol: socks5State.type,
        timeout: socks5State.timeout,
        country: socks5State.country,
      },
    };
    // console.log(qParams);

    return http.get('https://api.proxyscrape.com/v2/', qParams);
  }
}
export default new FproxyService();
